import script from "./Locations.vue?vue&type=script&setup=true&lang=js"
export * from "./Locations.vue?vue&type=script&setup=true&lang=js"

import "./Locations.vue?vue&type=style&index=0&id=35ffe675&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ffe675"]])

export default __exports__